let language = {
    "ADDRESS-BOOK-ADD-BUTTON": "新地址",
    "ADDRESS-BOOK-REMOVE-BUTTON": "删除",

    // TABLE
    "ADDRESS-BOOK-TABLE-HEADER-NAME": "姓名",
    "ADDRESS-BOOK-TABLE-HEADER-CONTACT": "联系",
    "ADDRESS-BOOK-TABLE-HEADER-ADDRESS": "地址",
    "ADDRESS-BOOK-TABLE-HEADER-TAG": "标签",
    "ADDRESS-BOOK-TABLE-HEADER-OPERATION": "操作",

    // STATUS
    "ADDRESS-BOOK-STATUS-DEFAULT": "默认",
    "ADDRESS-BOOK-STATUS-BUTTON-SET-DETAULT": "设置默认值",

    "ADDRESS-BOOK-EMPTY-TIPS": "你的地址为空",
    "ADDRESS-BOOK-NEW ADDRESS": "新地址",
    "ADDRESS-BOOK-EDIT-ADDRESS": "编码地址",

    "ADDRESS-BOOK-NEWADDRESS": "添加",
    "ADDRESS-BOOK-EDIT": "编辑",

    // DETAIL BUTTON
    "ADDRESS-BOOK-DETAIL-CANCEL-BUTTON": "取消",
    "ADDRESS-BOOK-DETAIL-SAVE-BUTTON": "保存",
    
};

export { language }